export default "__VITE_ASSET__BX$fJGi6__"